import Vue from "vue";
import VueRouter from "vue-router";
import { setBrowserTitle } from "@/utils/router";

Vue.use(VueRouter);

const importRoutes = () => {
  const requireRoutes = require.context("@/routes/", false, /\.js$/);
  let routes = [];

  requireRoutes.keys().forEach(fileName => {
    if (!requireRoutes(fileName).default) {
      return;
    }
    routes.push(...requireRoutes(fileName).default);
  });

  return routes;
};

const routes = importRoutes();

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, _, next) => {
  setBrowserTitle(to);

  next();
});

export default router;
